export default "<!-- <govco-footer></govco-footer> -->\n"